<div class="d-flex justify-content-between align-items-center w-100 r-text-base">
    <div class="text-primary text-nowrap" [attr.data-cy]='"colKeyValue_key_" + keyIdAppend' [ngClass]="keyClasses">{{key}}</div>
    <div class="dotted-space flex-grow-1"><div class="dotted-space-padding">&nbsp;</div></div>
    <div class="d-flex justify-content-between align-items-center">
        <div class="text-nowrap d-inline-block" [attr.data-cy]='"colKeyValue_value_" + valueIdAppend' [ngClass]="valueClasses">{{value}}</div>
        <ng-content></ng-content>
    </div>
</div>
